function SectionHeader({ number, title }) {
  return (
    <div className="section-header reveal">
      <span className="section-num">{number}</span>
      <h1 className="section-title">{title}</h1>
      <div className="section-line" />
    </div>
  );
}

export default SectionHeader;
